export default __webpack_public_path__ + "assets/349085c708fccb6ca414fe45a42d0147.png";